export const enum RugbyUnionResultId {
  Result = 2,
  RegularTime = 3,
  FirstHalf = 4,
  SecondHalf = 5,
  Extratime = 6,
  Penalty = 7,
  ExtratimeFirstHalf = 133,
  ExtratimeSecondHalf = 134,
  Winner = 411,
  Progress = 412,
}
